import React, { FC } from 'react';
import { RootState, AppDispatch } from '../store';
import { useSelector, useDispatch } from 'react-redux';
import { AppView, DeviceType, Platform, WriteDirection, Lightbox } from 'sofa-reborn-react';
import Banner from '../components/Banner';
import BannerMobile from '../components/Banner/BannerMobile';
import { setBannerHasBeenShown } from '../store/popOver';
import { localeService } from '../services';

const getTop = (): string => {
	let headerHeight = 0;
	const elements = Array.from(
		document.getElementsByClassName('header'),
		(header) => header as HTMLElement
	);
	for (const element of elements) {
		if (element && element.offsetHeight) {
			headerHeight = element.offsetHeight;
		}
	}
	return headerHeight + 'px';
};

const getLeft = (): string => {
	const leftOfScene = document.getElementById('scene')?.getBoundingClientRect().left || 0;
	return leftOfScene + 'px';
};

const BannerContainer: FC = () => {
	const platform = useSelector<RootState, Platform>((state) => state.deviceInfo.platform);
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const bannerHasBeenShown = useSelector<RootState, boolean>(
		(state) => state.popOver.bannerHasBeenShown
	);
	const appView = useSelector<RootState, AppView>((state) => state.application.appView);
	const bannerMessageType =
		localeService.getApplicationSetting('plannerBannerMessageType') || 'Information';
	const currentLightbox = useSelector<RootState, Lightbox>(
		(state) => state.application.currentLightbox
	);

	const dispatch = useDispatch<AppDispatch>();

	const onBannerClose = (): void => {
		dispatch(setBannerHasBeenShown(true));
	};

	if (
		deviceType === 'mobile' &&
		appView === 'build-view' &&
		currentLightbox !== 'product-intro-gallery' &&
		!bannerHasBeenShown
	) {
		return (
			<BannerMobile
				writeDirection={writeDirection}
				bannerMessageType={bannerMessageType as string}
				onBannerClose={onBannerClose}
			></BannerMobile>
		);
	} else {
		return (
			<Banner
				platform={platform}
				deviceType={deviceType}
				appView={appView}
				bannerMessageType={bannerMessageType as string}
				top={getTop()}
				left={getLeft()}
				onBannerClose={onBannerClose}
			></Banner>
		);
	}
};

export default BannerContainer;
